module.exports = "/_next/static/images/game-3-fingerprint-part-2-8f2121e1e7ea4cb4ca397a35db2757b5.png";